import Link from 'next/link';

export const ForgotPasswordButton = ({
  forgotPasswordHref,
}: {
  forgotPasswordHref?: string;
}) => {
  return (
    <div className='text-right mb-4'>
      <Link
        className='text-xs hover:underline text-semibold text-foreground inline-block'
        href={forgotPasswordHref || '/forgot-password'}
      >
        Olvidé mi contraseña
      </Link>
    </div>
  );
};
